<template>
  <div>
    <portal-target name="dropdown" slim />
    <div class="flex flex-col">
      <div class="h-screen flex flex-col" @click="hideDropdownMenus">
        <div class="md:flex">
          <div class="bg-gray-900 md:flex-shrink-0 md:w-56 px-6 py-4 flex items-center justify-between md:justify-center">
            <div class="mt-1 text-white">

              <svg version="1.1" id="Layer_1" class="h-7 fill-current" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 190.48 50" style="enable-background:new 0 0 190.48 50;" xml:space="preserve">
              <g>
                <path class="st0" d="M89.29,14.47v6.26c0,0.4-0.34,0.7-0.72,0.65c-0.39-0.05-0.74-0.08-1.1-0.08c-5.96,0-9.72,3.62-9.72,10.66
                  v16.08c0,0.36-0.29,0.66-0.64,0.66h-6.56c-0.35,0-0.64-0.29-0.64-0.66v-33.2c0-0.36,0.29-0.66,0.64-0.66h6.19
                  c0.35,0,0.64,0.29,0.64,0.66v4.38c2.17-3.48,6.02-5.28,11.26-5.42C88.99,13.81,89.29,14.1,89.29,14.47z"/>
                <path class="st0" d="M125.23,1.41v46.64c0,0.36-0.29,0.66-0.64,0.66h-6.25c-0.35,0-0.64-0.29-0.64-0.66v-3.8
                  c-2.63,3.3-6.52,4.91-11.1,4.91c-9.72,0-16.94-6.98-16.94-17.71s7.21-17.65,16.94-17.65c4.33,0,8.16,1.49,10.79,4.65V1.41
                  c0-0.36,0.29-0.66,0.64-0.66h6.56C124.95,0.75,125.23,1.05,125.23,1.41z M117.52,31.45c0-6.59-4.33-10.79-9.97-10.79
                  c-5.65,0-9.97,4.2-9.97,10.79s4.33,10.79,9.97,10.79C113.19,42.25,117.52,38.05,117.52,31.45z"/>
                <path class="st0" d="M132.35,14.2h6.56c0.35,0,0.64,0.29,0.64,0.66v33.2c0,0.36-0.29,0.66-0.64,0.66h-6.56
                  c-0.35,0-0.64-0.29-0.64-0.66v-33.2C131.71,14.49,132,14.2,132.35,14.2z"/>
                <path class="st0" d="M182.64,1.41v20.3c-0.42,5.45-5.19,6.27-7.83,6.56c-0.08-9.81-5.65-14.46-15.24-14.46
                  c-5.17,0-10.17,1.31-13.72,3.92c-0.26,0.19-0.34,0.56-0.19,0.85l2.46,4.7c0.18,0.35,0.62,0.45,0.93,0.22
                  c2.51-1.86,6.1-2.97,9.59-2.97c5.58,0,8.34,2.78,8.34,7.5v0.52h-8.66c-10.16,0-13.93,4.52-13.93,10.28
                  c0,6.01,4.83,10.34,12.48,10.34c5.02,0,8.66-1.68,10.54-4.65v3.54c0,0.36,0.29,0.66,0.64,0.66h6.13c0.35,0,0.64-0.29,0.64-0.66
                  V36.32c0-0.15-0.12-0.28-0.27-0.28l-7.3,0.15c-0.15,0-0.26,0.13-0.26,0.28v1.45c-1.32,3.55-4.64,5.36-8.47,5.36
                  c-4.01,0-6.4-1.87-6.4-4.78c0-2.52,1.44-4.59,6.78-4.59h8.09v0.01h7.79c12.48-0.19,15.53-10.16,15.71-15.86
                  c-0.26,9.76-3.51,13.58-7.12,15.74c-0.13,0.08-0.27,0.15-0.42,0.22c-0.19,0.09-0.31,0.29-0.31,0.5v13.53
                  c0,0.36,0.29,0.66,0.64,0.66h6.56c0.35,0,0.64-0.29,0.64-0.66V18.03v-0.01V1.41c0-0.36-0.29-0.66-0.64-0.66h-6.56
                  C182.93,0.75,182.64,1.05,182.64,1.41z"/>
                <g>
                  <path class="st0" d="M31,31.64c0-10.23,7.45-17.46,17.63-17.46c10.3,0,17.69,7.23,17.69,17.46s-7.39,17.52-17.69,17.52
                    C38.44,49.16,31,41.87,31,31.64z M58.49,31.64c0-6.52-4.22-10.68-9.87-10.68c-5.59,0-9.81,4.16-9.81,10.68
                    c0,6.52,4.22,10.68,9.81,10.68C54.27,42.32,58.49,38.16,58.49,31.64z"/>
                </g>
                <path class="st0" d="M131.26,4.25c0-2.38,1.87-4.25,4.4-4.25c2.53,0,4.4,1.76,4.4,4.08c0,2.5-1.82,4.42-4.4,4.42
                  C133.13,8.51,131.26,6.64,131.26,4.25z"/>
                <path class="st0" d="M19.33,12.33c-5.47,0-10.41,1.87-13.91,5.27C1.92,21,0,25.81,0,31.13c0,5.33,1.92,10.15,5.42,13.56
                  c3.5,3.42,8.44,5.3,13.91,5.3c4.77,0,8.85-1.43,11.87-4.15c0.25-0.22,0.29-0.61,0.1-0.88c-1.16-1.63-2.08-3.42-2.75-5.34
                  c-0.21-0.59-0.94-0.75-1.35-0.28c-2.02,2.35-4.73,3.58-7.93,3.58c-3.12,0-5.94-1.12-7.93-3.15c-2.09-2.13-3.19-5.13-3.19-8.66
                  c0-3.5,1.1-6.49,3.19-8.63c2-2.05,4.81-3.18,7.93-3.18c3.61,0,6.59,1.56,8.66,4.52c0.13,0.18,0.51,0.19,0.6-0.07
                  c0.77-2.2,1.85-4.22,3.24-6.02c0.2-0.26,0.18-0.65-0.06-0.88C28.69,13.9,24.43,12.33,19.33,12.33z"/>
              </g>
              </svg>

            </div>
            <dropdown class="md:hidden" placement="bottom-end">
              <svg
                class="fill-current text-white w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
              <div
                slot="dropdown"
                class="mt-2 px-8 py-4 shadow-lg bg-blue-800 rounded"
              >
                <Navigation />
              </div>
            </dropdown>
          </div>
          <div
            class="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center"
          >
            <div class="mt-1 mr-4">Segment Event Tester</div>
          </div>
        </div>
        <div class="flex flex-grow overflow-hidden">
          <Navigation
            class="bg-gray-800 flex-shrink-0 w-56 p-12 hidden md:block overflow-y-auto"
          />
          <div
            class="flex-1 bg-gray-100 overflow-hidden px-4 py-8 md:p-12 overflow-y-auto"
            scroll-region
          >
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../main.css";
import Navigation from "./Navigation";
import Dropdown from "./Dropdown";
export default {
  components: {
    Navigation,
    Dropdown
  },
  data() {
    return {
      showUserMenu: false
    }
  },
  methods: {
    hideDropdownMenus() {
      this.showUserMenu = false;
    }
  }
};
</script>
